import React, { useCallback, useEffect, useState } from 'react';
import { StarIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { trackPurchaseClick } from '../utils/MetaPixel';
export const Testimonials = () => {
  const testimonials = [{
    name: 'Mariana Rodríguez',
    location: 'Houston, TX',
    text: 'Salgo del trabajo agotada y en 12–15 min tengo cena real. Bajé a 1 pedido de UberEats por semana y la airfryer trabaja a todo dar. Las fotos ayudan muchísimo.'
  }, {
    name: 'Julián Martínez',
    location: 'Miami, FL',
    text: 'Soy de comer abundante y pensé que iba a quedarme con hambre. Nada que ver: porciones claras y tips para sumar proteína. El sándwich crocante de pollo es infalible.'
  }, {
    name: 'Camila Herrera',
    location: 'Los Angeles, CA',
    text: 'Tengo airfryer chica y cero balanza. Igual me salió todo. Me facilitó el lunch para la oficina y los snacks para la universidad. La sección de alternativas es oro.'
  }, {
    name: 'Diego Morales',
    location: 'Chicago, IL',
    text: 'Lo compré porque quería comer mejor sin cocinar horas. En dos semanas ya hice 18 recetas. La de bastoncitos de pescado + ensalada quedó increíble para los niños.'
  }, {
    name: 'Valentina Díaz',
    location: 'San Antonio, TX',
    text: "Mi miedo era que 'fit = sin sabor'. Todo lo contrario. Condimentos bien explicados, tiempos reales (cronómetro en mano). Y me encantó que tenga macros orientativos."
  }];
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const nextTestimonial = useCallback(() => {
    setCurrentIndex(prevIndex => (prevIndex + 1) % testimonials.length);
  }, [testimonials.length]);
  const prevTestimonial = useCallback(() => {
    setCurrentIndex(prevIndex => prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1);
  }, [testimonials.length]);
  useEffect(() => {
    if (!isPaused) {
      const interval = setInterval(() => {
        nextTestimonial();
      }, 5000);
      return () => clearInterval(interval);
    }
    return undefined;
  }, [isPaused, nextTestimonial]);
  return <section className="py-12 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-364">
      <div className="max-w-7xl mx-auto" data-id="element-365">
        <div className="text-center mb-10" data-id="element-366">
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-367">
            Lo que dicen quienes ya lo usan
          </h2>
          <div className="flex items-center justify-center gap-1 mb-2" data-id="element-368">
            <StarIcon className="h-5 w-5 text-yellow-500 fill-yellow-500" data-id="element-369" />
            <StarIcon className="h-5 w-5 text-yellow-500 fill-yellow-500" data-id="element-370" />
            <StarIcon className="h-5 w-5 text-yellow-500 fill-yellow-500" data-id="element-371" />
            <StarIcon className="h-5 w-5 text-yellow-500 fill-yellow-500" data-id="element-372" />
            <StarIcon className="h-5 w-5 text-yellow-500 fill-yellow-500" data-id="element-373" />
            <span className="ml-2 text-lg font-medium" data-id="element-374">4.9/5</span>
          </div>
          <p className="text-gray-600" data-id="element-375">Basado en reseñas verificadas</p>
        </div>
        <div className="relative max-w-3xl mx-auto" onMouseEnter={() => setIsPaused(true)} onMouseLeave={() => setIsPaused(false)} data-id="element-376">
          <div className="bg-gray-50 p-6 rounded-lg shadow-md mx-auto" data-id="element-377">
            <div className="flex items-center gap-1 mb-3" data-id="element-378">
              <StarIcon className="h-4 w-4 text-yellow-500 fill-yellow-500" data-id="element-379" />
              <StarIcon className="h-4 w-4 text-yellow-500 fill-yellow-500" data-id="element-380" />
              <StarIcon className="h-4 w-4 text-yellow-500 fill-yellow-500" data-id="element-381" />
              <StarIcon className="h-4 w-4 text-yellow-500 fill-yellow-500" data-id="element-382" />
              <StarIcon className="h-4 w-4 text-yellow-500 fill-yellow-500" data-id="element-383" />
            </div>
            <div className="mb-4 italic text-gray-700 min-h-[100px]" data-id="element-384">
              "{testimonials[currentIndex].text}"
            </div>
            <div className="flex items-center" data-id="element-385">
              <div className="bg-teal-100 h-10 w-10 rounded-full flex items-center justify-center mr-3" data-id="element-386">
                <span className="font-semibold text-teal-800" data-id="element-387">
                  {testimonials[currentIndex].name.charAt(0)}
                </span>
              </div>
              <div data-id="element-388">
                <p className="font-semibold text-gray-900" data-id="element-389">
                  {testimonials[currentIndex].name}
                </p>
                <p className="text-sm text-gray-600" data-id="element-390">
                  {testimonials[currentIndex].location}
                </p>
              </div>
            </div>
          </div>
          <button onClick={prevTestimonial} className="absolute left-0 top-1/2 -translate-y-1/2 -ml-4 bg-white p-2 rounded-full shadow-md hover:bg-gray-100" aria-label="Testimonio anterior" data-id="element-391">
            <ChevronLeftIcon className="h-6 w-6 text-gray-600" data-id="element-392" />
          </button>
          <button onClick={nextTestimonial} className="absolute right-0 top-1/2 -translate-y-1/2 -mr-4 bg-white p-2 rounded-full shadow-md hover:bg-gray-100" aria-label="Siguiente testimonio" data-id="element-393">
            <ChevronRightIcon className="h-6 w-6 text-gray-600" data-id="element-394" />
          </button>
          <div className="flex justify-center mt-4 gap-2" data-id="element-395">
            {testimonials.map((_, index) => <button key={index} onClick={() => setCurrentIndex(index)} className={`h-2 w-2 rounded-full transition-colors duration-200 ${index === currentIndex ? 'bg-teal-600' : 'bg-gray-300'}`} aria-label={`Ir al testimonio ${index + 1}`} data-id="element-396" />)}
          </div>
        </div>
        <div className="mt-10 text-center" data-id="element-397">
          <p className="text-lg font-medium text-gray-700" data-id="element-398">
            8 de cada 10 usuarios lo utilizan 4+ veces por semana
          </p>
          <div className="flex justify-center mt-4" data-id="element-399">
            <a href="https://organicecomm.com/cart/51818275930293:1" className="inline-block bg-teal-600 hover:bg-teal-700 text-white font-bold py-3 px-6 rounded-lg shadow-lg hover:shadow-xl transition duration-300" onClick={trackPurchaseClick} data-id="element-400">
              Quiero mi recetario por $17 USD
            </a>
          </div>
        </div>
      </div>
    </section>;
};